import React, { useState, useEffect } from 'react'
import { useForm, Controller } from 'react-hook-form'
import { Panel, Row, Col, ControlLabel, RadioGroup, Radio, Icon } from 'rsuite'
import SaveButton from '../../components/buttons/saveButton/SaveButton'
import './styles.less'
import InputForm from '../../components/forms/input/InputForm'
import { isRequired, isValidators } from '../../utils/ValidatorUtils'
import classNames from 'classnames'
import AppContext from '../../context/AppContext'
import {
  getProgressReportSubprojectClose,
  saveBestpractice,
} from '../../redux/actions/progressReportSubproject'
import { doneLoading, startLoading } from '../../utils/loading'
import { SAVE_SUCCESS_MSG } from '../../constants/msgText'
import notification from '../../utils/notification'
import { getValueFromOptions } from '../../utils/dataUtil'
import { useDispatch } from 'react-redux'
import { getSchemaSubProjectDep6Sidebar } from '../../redux/actions/sidebar'

export default function BestPracticeWidgets({
  schema: _schema,
  isRole,
  isReadOnly,
  period,
  projectCode,
  projectVersionId,
  progressActivityId,
  setProgressReportsId = () => {},
  installmentPlanId,
  disabled,
  ...props
}) {
  const { showCommandButton, isEdit, onChangeIsEdit } = props
  const { theme } = React.useContext(AppContext)
  const [isError, setIsError] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const { register, handleSubmit, errors, control, setValue, getValues, clearErrors } = useForm()
  const [formSchema, setFormSchema] = useState(_schema)
  const [progressValue, setProgressValue] = useState(null)
  const [progressFilesValue, setProgressFilesValue] = useState(null)
  const [isBestPracticeValue, setIsBestPracticeValue] = useState(false)
  const projectId = sessionStorage.getItem('projectId')
  const dispatch = useDispatch()

  useEffect(() => {
    setFormSchema(_schema)
    setProgressFilesValue(_schema?.healthInnovation?.values || null)
    if (formSchema.bestPractice.isBestPractice.value === 0) {
      setIsBestPracticeValue(true)
    } else if (formSchema.bestPractice.isBestPractice.value === 1) {
      setIsBestPracticeValue(false)
    } else {
      setIsBestPracticeValue(formSchema.bestPractice.isBestPractice.value)
    }
    setProgressValue(_schema?.values || null)
  }, [_schema])

  const onSubmit = (data) => {
    const request = {
      projectVersionId: projectVersionId || '',
      projectCode: projectCode || '',
      period: period || 0,
      installmentPlanDetailId: installmentPlanId,
      id: progressActivityId || '',
      isBestPractice: data.isBestPractice || 0,
      bestPracticeDescriton: data.bestPracticeDetail || '',
    }

    handleCallService(request)
  }

  const handleCallService = async (request) => {
    startLoading()
    setIsLoading(true)
    setIsError()

    try {
      const response = await saveBestpractice(request)

      if (response) {
        notification.open('success', {
          title: SAVE_SUCCESS_MSG,
        })
        setProgressReportsId(response.progressReportsId)
        handleGetSchema()
        await dispatch(getSchemaSubProjectDep6Sidebar(projectId))
      } else {
        setErrorMsg({ type: 'error', description: response.errorMessage })
      }
    } catch (error) {
      console.error('try catch error ', error)
      setIsError(true)
    }
    setIsLoading(false)
    doneLoading()
  }

  const handleGetSchema = async () => {
    startLoading()
    try {
      const response = await getProgressReportSubprojectClose(
        period,
        projectCode,
        projectVersionId,
        installmentPlanId
      )

      if (response) {
        setFormSchema(response?.forms?.otherOutcomes)
      }
    } catch (e) {
      console.log(' error', e)
    }
    doneLoading()
  }

  return (
    <div>
      <Panel
        header={formSchema.bestPractice.title}
        collapsible
        defaultExpanded
        style={{ marginTop: 10 }}
      >
        <div style={{ paddingLeft: 160, paddingRight: 160, marginTop: -20 }}>
          <Row style={{ marginTop: 20 }}>
            <Col lg={8} md={8} sm={8} xs={8}>
              {/* {!disabled ? (
                <> */}
              <Controller
                name={formSchema.bestPractice.isBestPractice.name}
                defaultValue={formSchema.bestPractice.isBestPractice.value}
                control={control}
                render={(props) => {
                  return (
                    <RadioGroup
                      value={props.value}
                      onChange={(value) => {
                        props.onChange(value)
                        let v = false
                        if (value == 0) {
                          v = true
                        }
                        setIsBestPracticeValue(v)
                      }}
                    >
                      <ControlLabel
                        className={classNames(
                          isRequired(formSchema.bestPractice.isBestPractice.validators) &&
                            'required'
                        )}
                      >
                        {formSchema.bestPractice.isBestPractice.label}
                      </ControlLabel>
                      {formSchema.bestPractice.isBestPractice.options.map((item, index) => {
                        return (
                          <>
                            <Radio key={index} value={item.value}>
                              {item.label}
                            </Radio>
                          </>
                        )
                      })}
                    </RadioGroup>
                  )
                }}
              />
              {/* </>
              ) : (
                <>
                  <b>{formSchema.bestPractice.isBestPractice.label}</b>

                  <p>
                    <Icon icon="dot-circle-o" style={{ marginRight: 5, color: '#14997a' }} />
                    {`${getValueFromOptions(
                      formSchema.bestPractice.isBestPractice.options.map((item, index) => {
                        return {
                          ...item,
                          value: item.value.toString(),
                        }
                      }),
                      formSchema?.bestPractice?.isBestPractice?.value
                    )}`}
                  </p>
                </>
              )} */}
            </Col>
            <Col lg={16} md={16} sm={16} xs={16}>
              {isBestPracticeValue && (
                <>
                  {!disabled ? (
                    <>
                      <ControlLabel
                        className={classNames(
                          isRequired(formSchema.bestPractice.bestPracticeDetail.validators) &&
                            'required'
                        )}
                      >
                        {formSchema.bestPractice.bestPracticeDetail.label}
                      </ControlLabel>
                      <InputForm
                        schema={formSchema.bestPractice.bestPracticeDetail}
                        // placeholder={
                        //   'ระบุ' + formSchema.bestPractice.bestPracticeDetail.placeholder
                        // }
                        value={formSchema.bestPractice.value}
                        register={register}
                        Controller={Controller}
                        control={control}
                        errors={errors}
                        setValue={setValue}
                        clearErrors={clearErrors}
                        hideLabel={true}
                      />
                    </>
                  ) : (
                    <>
                      <b> {formSchema.bestPractice.bestPracticeDetail.label}</b>
                      <p>{formSchema.bestPractice.bestPracticeDetail.value}</p>
                    </>
                  )}
                </>
              )}
            </Col>
          </Row>
        </div>

        {!disabled && (
          <Row style={{ marginTop: 20 }}>
            <Col lg={24} md={24} sm={24} xs={24} style={{ textAlign: 'right' }}>
              <div style={{ paddingLeft: 40, paddingRight: 25 }}>
                <SaveButton disabled={isLoading} onClick={handleSubmit(onSubmit)}>
                  บันทึก
                </SaveButton>
              </div>
            </Col>
          </Row>
        )}
      </Panel>
    </div>
  )
}
